import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const HorizontalMovementPage = lazy(() => import('./HorizontalMovementPage'));
const path = 'reports/horizontal-movement';
const HorizontalMovementRoute: FuseRouteItemType = {
	path: path,
	element: <HorizontalMovementPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Horizontal Movement',
					helpName: 'Horizontal Movement',
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default HorizontalMovementRoute;
